export const ONBOARDING_STEPS = [
  {
    questionKey: 'industry',
    routeName: 'onboardingIndustry',
    routePath: '/onboarding/industry',
  },
  {
    questionKey: 'anotherService',
    routeName: 'onboarding02',
    routePath: '/onboarding/02',
  },
] as const

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number]
export type OnboardingQuestionKey = OnboardingStep['questionKey']

export const ONBOARDING_QUESTION_ORDER = ONBOARDING_STEPS.map(
  (step) => step.questionKey,
) as readonly OnboardingQuestionKey[]

export const ONBOARDING_QUESTION_KEYS = ONBOARDING_STEPS.reduce(
  (acc, step) => {
    acc[step.questionKey] = step.questionKey
    return acc
  },
  {} as Record<OnboardingQuestionKey, OnboardingQuestionKey>,
)

export function getNextOnboardingStep(answers: Array<{ questionKey: string }> | undefined): OnboardingStep | null {
  const answered = new Set((answers ?? []).map((answer) => answer.questionKey))
  return ONBOARDING_STEPS.find((step) => !answered.has(step.questionKey)) ?? null
}

export function isOnboardingQuestionKey(value: string): value is OnboardingQuestionKey {
  return ONBOARDING_QUESTION_ORDER.includes(value as OnboardingQuestionKey)
}
